import { isArray, isEmpty, isString, isUndefined, memoize } from "lodash-es";
import { compile } from "path-to-regexp";

import { IURLSearchParams } from "@/browser";

const compilerCache = new Map();
export const pathFrom = (path: string, params: IURLSearchParams) => {
  try {
    if (compilerCache.has(path)) {
      return compilerCache.get(path)(params);
    }

    const generator = compile(path);
    compilerCache.set(path, generator);
    return generator(params);
  } catch (error) {
    if (error instanceof TypeError) {
      return path;
    }

    throw error;
  }
};

const searchToBody = (search: string) => {
  let params: any = {}; // TODO any

  new URLSearchParams(search).forEach((value, key) => {
    let parsed = value;

    try {
      parsed = JSON.parse(value);
    } catch {
      parsed = value;
    }

    if (!isUndefined(params[key])) {
      let arr = [params[key]];

      if (isArray(params[key])) {
        arr = [...params[key]];
      }

      params = { ...params, [key]: [...arr, parsed] };
      return;
    }
    params = { ...params, [key]: parsed };
  });

  return params;
};
const searchToKey = (search: string) => search;

export const searchTo = memoize(searchToBody, searchToKey);

export const searchFrom = (searchObj?: any) => {
  if (isEmpty(searchObj)) {
    return "";
  }

  return Object.keys(searchObj)
    .map(key => {
      let value = searchObj[key];

      if (isUndefined(value)) {
        return;
      }

      value = isString(value) ? value : JSON.stringify(value);

      return `${key}=${encodeURIComponent(value)}`;
    })
    .join("&");
};
